import { Injectable } from '@angular/core';
import { AudioDeviceConnectedModalService } from '@libs/shared-services';

/**
 * FFDNotes flavour of {@link AudioDeviceConnectedModalService}, provided by `FfdNotesLayoutComponent`.
 *
 * The base service loads the site's operatories so a paired phone can be tied to a named chair, and it reads
 * them off the schedule endpoint (`GET /v1/sites/:siteId/appointments`). FFDNotes sites are not PMS
 * integrated and have no schedule, so that request only ever fails - and the base service answers a failure
 * with a "Unable to load schedule information" toast, which is noise for a product that has no schedule to
 * begin with.
 *
 * Skipping the fetch leaves the operatory list empty. That is the intended end state here, not a degraded
 * one: the modal's dropdown renders its free-text custom input independently of the options, so the user
 * still names the device and starts voice typing.
 */
@Injectable()
export class FfdNotesAudioDeviceConnectedModalService extends AudioDeviceConnectedModalService {
  public override fetchOperatories(): void {
    return;
  }
}
